import { URL_PATHS } from "constants/index"
import React, { useState } from "react"
import { Link } from "react-router-dom"
import {
  Collapse,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import { checkClientConfig, checkPermission } from "utils"

const PlatformSetup = () => {
  const [platformSetupToggle, setPlatformSetupToggle] = useState(false)
  const [appScreenSetupToggle, setAppScreenSetupToggle] = useState(false)
  return (
    <React.Fragment>
      <Dropdown
        isOpen={platformSetupToggle}
        toggle={() => {
          setPlatformSetupToggle(!platformSetupToggle)
          if (platformSetupToggle) {
            setAppScreenSetupToggle(false)
          }
        }}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          Platform Setup
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block ms-1" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <Link to={URL_PATHS.PLATFORM_SETTINGS} className="dropdown-item my-1">
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            <span>Platform Settings</span>
          </Link>
          <DropdownItem
            style={{ cursor: "pointer" }}
            onClick={() => setAppScreenSetupToggle(!appScreenSetupToggle)}
            toggle={false}
            className="my-1"
          >
            <i className="bx bx-mobile-alt font-size-16 align-middle me-1" />
            App Screen Setup{" "}
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </DropdownItem>
          <Collapse isOpen={appScreenSetupToggle}>
            {/* {checkPermission("manage_onboarding_screens") && (
              <Link to={URL_PATHS.ONBOARDING_FLOW} className="dropdown-item ">
                <span className="ms-3">Onboarding flow</span>
              </Link>
            )} */}
            {checkClientConfig("landing_page") &&
              checkPermission("manage_landing_page") && (
                <Link
                  to={URL_PATHS.SETUP_LANDING_PAGE}
                  className="dropdown-item"
                >
                  <span className="ms-3">Landing Screen</span>
                </Link>
              )}
            {checkPermission("manage_list_screen") && (
              <Link to={URL_PATHS.SETUP_LIST_SCREEN} className="dropdown-item">
                <span className="ms-3">List Screen</span>
              </Link>
            )}
            {checkClientConfig("contact_us") &&
              checkPermission("manage_contact_us_list") && (
                <Link to={URL_PATHS.SETUP_CONTACT_US} className="dropdown-item">
                  <span className="ms-3">Contact Us Screen</span>
                </Link>
              )}
            <div className="dropdown-divider" />
          </Collapse>
          <Link to={URL_PATHS.TAGS} className="dropdown-item my-1">
            <i className="bx bx-purchase-tag font-size-16 align-middle me-1" />
            <span>Tag Setup</span>
          </Link>
          <Link to={URL_PATHS.BUSINESS_UNITS} className="dropdown-item my-1">
            <i className="bx bxs-business font-size-16 align-middle me-1" />
            <span>Business Units</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default PlatformSetup
